module.exports = __webpack_public_path__ + "img/promocode-applied-icon.a433a414.svg";